<template>
  <div class="Instrument" v-if="instrumentData">
    <!--顶部下载-->
    <headdownload></headdownload>
    <!--顶部游戏大图-->
    <header-cover :cover-url="instrumentData.detail.coverImage"></header-cover>
    <!--  游戏简介-->
    <div class="area describe" v-if="instrumentData.baseInfo">
      <describe :icon-url="instrumentData.baseInfo.icon"
                :title="instrumentData.baseInfo.name"
                type="辅助工具"
                :brief="instrumentData.detail.devRecommend"
                score="hide"
      ></describe>
    </div>
    <!--  文章标题-->
    <div class="area area-title" v-if="instrumentData.topArticle">
      <article-title
        :title-txt="instrumentData.topArticle.title"
        title-task="查看详情"
      ></article-title>
    </div>
    <!--  功能图标-->
    <function v-if="false" :function-data="functionData"></function>
    <!--  游戏截图-->
    <div class="area area-deficiency" v-if="pics">
      <exhibition :exhibition-list="pics" :type-list="toolTags"></exhibition>
    </div>
    <!--游戏描述-->
    <div class="area" v-if="instrumentData.baseInfo">
      <introduce title="工具介绍"
                 :version-info="instrumentData.baseInfo.gameVersion"
                 :editor-recommend-list="description"
                 pack-txt="hide"
      ></introduce>
    </div>
    <!--底部下载-->
    <floordownload></floordownload>
  </div>
</template>

<script>
import Exhibition from './template/exhibition'
import Function from './template/function'
import Headdownload from './template/headdownload'
import Floordownload from './template/floordownload'
import HeaderCover from './template/headerCover'
import Describe from './template/describe'
import ArticleTitle from './template/articleTitle'
import overallData from '../../public/js/overall'
import axios from 'axios'
import Introduce from './template/introduce'
export default {
  name: 'Instrument',
  components: { Introduce, ArticleTitle, Describe, HeaderCover, Floordownload, Headdownload, Function, Exhibition },
  data () {
    return {
      axiosUrl: overallData.axiosUrl, // 测试环境
      instrumentData: null,
      // 功能图标
      functionData: [],
      // 游戏截图
      pics: null,
      // 截图标签
      toolTags: [],
      // 工具介绍
      description: [],
      // 工具id
      id: ''
    }
  },
  created () {
    const urlDataJson = {}
    if (window.location.hash.indexOf('?') !== -1) {
      const urlData = window.location.hash.split('?')[1].split('&')
      for (const urlDatum of urlData) {
        urlDataJson[urlDatum.split('=')[0]] = urlDatum.split('=')[1]
      }
      console.log('urlDataJson', urlDataJson)
    }
    this.getDetail(urlDataJson.toolId)
    this.getListByGpmId(urlDataJson.toolId)
    this.id = urlDataJson.toolId
  },
  methods: {
    openOfficial () {
      window.location.href = 'sbapp:///game_detail?is_assist_plug=1&id=' + this.id
      window.location.href = 'https://m.ccspeed.cn/'
    },
    // 功能图标
    getListByGpmId (gameId) {
      const _this = this
      axios.get(this.axiosUrl + '/game/helper/getListByGpmId', {
        params: {
          gameId: gameId // ID
        }
      })
        .then(function (response) {
          if (response.code === 100000) {
            _this.functionData = response.data
          }
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getDetail (toolId) {
      const _this = this
      axios.get(this.axiosUrl + '/auxiliaryTool/gpm/detail', {
        params: {
          toolId: toolId // ID
        }
      })
        .then(function (response) {
          if (response.code === 100000) {
            _this.instrumentData = response.data
            if (response.data.detail.pics) {
              _this.pics = JSON.parse(response.data.detail.pics)
            }
            if (response.data.detail.toolTags) {
              const toolTags = response.data.detail.toolTags.split(',')
              toolTags.map(function (item) {
                console.log(item)
                _this.toolTags.push({
                  name: item
                })
              })
            }
            if (response.data.detail.description) {
              _this.description = response.data.detail.description.split('\r\n')
            }
          }
          console.log('response', response)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }

}
</script>
<style>
.my-swipe{
  height: 100%;
}
.my-swipe .van-swipe-item {
  height: 100%;
}
.my-swipe .van-swipe__indicator{
  width: 8px;
  height: 2px;
  border-radius: 1px;
}
.my-swipe .van-swipe__indicator--active{
  width: 8px;
  height: 2px;
  background: linear-gradient(90deg, #2992FF, #00F2C2);
  border-radius: 1px;
}
</style>
<style scoped lang="scss">
.Instrument{
  padding-bottom: 50px;
}
.area{
  padding: 0 13px;
  margin-bottom: 30px;
}
.describe{
  margin-bottom: 0px;
}
.area-deficiency{
  padding-right: 0;
  margin-bottom: 25px;
}
.area-title{
  background-color: #272D3B;
  margin-bottom: 10px;
}

</style>
